/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Essay_P2Inputs */

const en_pc_cmp_essay_p2 = /** @type {(inputs: Pc_Cmp_Essay_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The gap shows in heavier workflows. If you rewrite paragraphs inside existing PDFs, convert to and from Word every day, send contracts out for signature or OCR scans in Chinese or Arabic, Acrobat is still the tool. ArtCraft PdfCraft is moving quickly toward those features, so the sensible plan is to install both, use PdfCraft first, and check back with each release.`)
};

const zh_pc_cmp_essay_p2 = /** @type {(inputs: Pc_Cmp_Essay_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差距体现在更重的工作流上。如果你需要改写 PDF 中已有的段落、每天在 PDF 与 Word 之间转换、发送合同签署，或对中文、阿拉伯文扫描件做 OCR，Acrobat 仍是更合适的工具。ArtCraft PdfCraft 正在快速补齐这些功能，所以明智的做法是两者都装上，优先使用 PdfCraft，并在每次新版本发布时回来看看。`)
};

/**
* | output |
* | --- |
* | "The gap shows in heavier workflows. If you rewrite paragraphs inside existing PDFs, convert to and from Word every day, send contracts out for signature or O..." |
*
* @param {Pc_Cmp_Essay_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_essay_p2 = /** @type {((inputs?: Pc_Cmp_Essay_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Essay_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_essay_p2(inputs)
	return zh_pc_cmp_essay_p2(inputs)
});
export { pc_cmp_essay_p2 as "pc.cmp.essay_p2" }